import React, { CSSProperties } from 'react';
import '../css/sectionTitle.css';

interface SectionTitleProps {
  label?: string;
  title?: string;
  description?: string;
  className?: string;
  styleInjectionLabel?: CSSProperties;
  styleInjectionTitle?: CSSProperties;
}

const SectionTitle: React.FC<SectionTitleProps> = ({
  label,
  title,
  description,
  className,
  styleInjectionLabel,
  styleInjectionTitle
}) => {

  const styleVaribleLabel =  {
    '--career-label-hero-text-color': styleInjectionLabel?.color,
    '--career-label-hero-text-weight': styleInjectionLabel?.fontWeight,
    '--career-label-hero-text-font-style': styleInjectionLabel?.fontStyle,
    '--career-label-hero-text-font-size': styleInjectionLabel?.fontSize,
  }  as CSSProperties

  const styleVaribleTitle =  {
    '--career-title-hero-text-color': styleInjectionTitle?.color,
    '--career-title-hero-text-weight': styleInjectionTitle?.fontWeight,
    '--career-title-hero-text-font-style': styleInjectionTitle?.fontStyle,
    '--career-title-hero-text-font-size': styleInjectionTitle?.fontSize,
  }  as CSSProperties

  return (
    <div className={`scl--web-component-section-title-container ${className || ''}`}>
      {label && (
        <div className="scl--web-component-section-label-container">
          <div className="scl--web-component-section-label-wrapper">
            <div className="scl--web-component-section-left-bracket" />
            <span className="scl--web-component-section-label-text" style={styleVaribleLabel}>{label}</span>
            <div className="scl--web-component-section-right-bracket" />
          </div>
        </div>
      )}

      <div className="scl--web-component-section-title-text-container">
        <h2 className="scl--web-component-section-title-text" style={styleVaribleTitle}>{title}</h2>
      </div>

      {description && (
        <div className="scl--web-component-section-description-container">
          <p className="scl--web-component-section-description-text">{description}</p>
        </div>
      )}
    </div>
  );
};

export default SectionTitle;
